import React, { useEffect } from "react";
import { styled } from "styled-components";
import { Text } from "../../TextConstants";
import FeedbackShare from "../../components/Booking/FeedbackShare";

const VisitHours = ({ visitHours, contactInfo }) => {
  return (
    <ParkLabelValueWrapper>
      <ParkContainer>
        <ParkLabel>{Text.visitingHours}</ParkLabel>
        {/* <FeedbackSpaceMobile> */}
          <FeedbackShare
            email={contactInfo?.email}
            phone={contactInfo?.phone}
            rating={contactInfo?.actualRating}
            totalRating={contactInfo?.totalRating}
          />
        {/* </FeedbackSpaceMobile> */}
      </ParkContainer>

      {visitHours?.map((vh) => (
        <ParkValue>
          <span>{vh.day}</span>
          <span style={{ textAlign: "right" }}>{vh.hr}</span>
        </ParkValue>
      ))}
    </ParkLabelValueWrapper>
  );
};

const ParkLabel = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
`;

const ParkValue = styled.div`
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ParkLabelValueWrapper = styled.div`
  width: 100%;
  margin-top: 1rem;
`;
const ParkContainer = styled.div`
  // width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.3rem;
  @media only screen and (max-width: 414px) {
    margin-bottom: 0.6rem;
  }
`;
const FeedbackSpaceMobile = styled.div`
  display: none;
  @media only screen and (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border: 1px solid red;
  }
`;
export default VisitHours;
